import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import {Form} from 'react-bootstrap';
import {URL_IMG} from '../../../configs/urlConfigs';
import {LBL_EVENT,LBL_EVENTS} from '../../../configs/labelConfigs';

class Events extends Component {
    
    render(){

        // const { affiliateData,formErrors, locations} = this.props; 
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;
        return(
            <Form onSubmit={e => this.props.updateFormData(e)}>
                <Form.Group>
                    <div className="box">
                        <div className="tab-head">
                            <h6>{LBL_EVENTS} {(companyName) && <span>{' - '+companyName}</span>} </h6>
                        </div>
                        <div className="box-content">
                            <div className="table-responsive">
                                <table id="data-table" className="table" style={{width:"100%"}}>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Ref No</th>
                                            <th>{LBL_EVENT} Title</th>
                                            <th>Location</th>
                                            <th>Client</th>
                                            <th>{LBL_EVENT} Status</th>
                                            <th>Team Count</th>
                                            <th>PO #</th>
                                            <th>Schedule</th>
                                            <th className="action">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>16590</td>
                                            <td>TH collective @ TH collective <br/> 03/10/2019
                                                03:00-04/10/2019</td>
                                                <td>Parkplaza westministre bridge</td>
                                            <td>Essential projects</td>
                                            <td>Estimation</td>
                                            <td>10/15</td>
                                            <td>ORDR16343</td>
                                            <td><Link  to="#"><i className="lar la-clock pl-3" style={{fontSize:24}}></i></Link></td>
                                            <td>
                                                <div className="dropdown">
                                                    <button className="dropdown-toggle" type="button"
                                                        id="dropdownMenuButton2" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <img src={require('../../../'+URL_IMG+'action.png')} alt="Action" />
                                                    </button>
                                                    <div className="dropdown-menu"
                                                        aria-labelledby="dropdownMenuButton">
                                                        <Link className="dropdown-item edit" to="#">Edit</Link>
                                                        <Link className="dropdown-item delete"
                                                            to="#">Delete</Link>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Form.Group>
            </Form>
        )
    }

}
export default Events;